import React, { useState, useEffect } from 'react'
import { Button, Modal, OverlayTrigger, Popover } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { FacebookIcon, FacebookShareButton, TwitterIcon, TwitterShareButton } from 'react-share'
import { success } from '@services/toast-service'
import { createVideoViewingLog } from '@services/api/videoApi'

let interval: any
const VideoPopup = (props: any) => {
  const { video, showModal, onCloseModal } = props
  const [playedTime, setPlayedTime] = useState(0)
  const [duration, setDuration] = useState(0)
  const [countViewed, setCountViewed] = useState(video.countViewed || 0)
  const videoShareUrl = `${window.location.origin}?video=${video.id}`

  useEffect(() => {
    if (!showModal) {
      setPlayedTime(0)
      setDuration(0)
      if (interval) {
        clearInterval(interval)
      }
    }
  }, [showModal])

  useEffect(() => {
    setCountViewed(video.countViewed || 0)
  }, [video])

  const copyToClipboard = (textToCopy: string) => {
    navigator.clipboard.writeText(textToCopy)
    success('クリップボードへのコピーに成功')
  }

  const onStartVideo = () => {
    interval = setInterval(() => {
      setPlayedTime(prevPlayedTime => prevPlayedTime + 1)
    }, 1000)
  }

  const onPauseVideo = () => {
    if (interval) {
      clearInterval(interval)
    }
    if (playedTime >= duration) {
      updateViewVideo()
      setPlayedTime(0)
    }
  }

  const onLoadMetadata = (e: any) => {
    setDuration(Math.floor(e.target.duration))
  }

  const updateViewVideo = async () => {
    try {
      const data = {
        videoId: video.id,
        isWatchedFull: playedTime >= duration,
        videoType: video.videoType,
        timeWatched: playedTime
      }
      video.countViewed += 1
      setCountViewed(video.countViewed)
      await createVideoViewingLog(data)
    } catch (error) {
      console.error(error)
    }
  }

  const onHideModal = () => {
    if (playedTime >= 25) {
      updateViewVideo()
    }
    onCloseModal()
  }

  const popover = (
    <Popover id="popover-nice">
      <Popover.Body>
        <div className="d-flex justify-content-between">
          <div className="img-wrapper">
            <div>
              <img src="/assets/img/gmts-kun_icon_moji_tabetai_20px.png" alt="want-to-eat" />
            </div>
            <p className="mb-0">{video.countWantToEat}</p>
          </div>
          <div className="img-wrapper">
            <div>
              <img src="/assets/img/gmts-kun_icon_moji_ikitai_20px.png" alt="want-to-try" />
            </div>
            <p className="mb-0">{video.countWantToTry}</p>
          </div>
          <div className="img-wrapper">
            <div>
              <img src="/assets/img/gmts-kun_icon_moji_iine_20px.png" alt="liked" />
            </div>
            <p className="mb-0">{video.countLiked}</p>
          </div>
        </div>
      </Popover.Body>
    </Popover>
  )

  const popoverShare = (
    <Popover id="popover-share">
      <Popover.Body>
        <p className="text-center">送信先</p>
        <div className="d-flex justify-content-between">
          <FacebookShareButton url={videoShareUrl} className="facebook-share me-3">
            <FacebookIcon />
          </FacebookShareButton>
          <TwitterShareButton url={videoShareUrl} className="twitter-share me-3">
            <TwitterIcon />
          </TwitterShareButton>
          <Button className="copy-to-clipboard" onClick={() => copyToClipboard(videoShareUrl)}>
            <i className="bi bi-clipboard" />
          </Button>
        </div>
      </Popover.Body>
    </Popover>
  )

  return (
    <Modal
      show={showModal}
      onHide={onHideModal}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {video.title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="relative">
          <video controls autoPlay controlsList="nodownload" width="100%" className="video-player" onPause={onPauseVideo} onPlay={onStartVideo} onLoadedMetadata={onLoadMetadata}>
            <source src={video.url} type="video/mp4" />
            <track kind="captions" />
            Your browser does not support HTML video.
          </video>
          {video.videoType === 1
            && (
              <>
                <OverlayTrigger trigger="click" placement="bottom" rootClose overlay={popoverShare}>
                  <Button className="share-info">
                    <i className="bi bi-share-fill" />
                  </Button>
                </OverlayTrigger>
                <OverlayTrigger trigger="click" placement="bottom" rootClose overlay={popover}>
                  <Button className="nice-info">
                    <img src="/assets/img/gmts-kun_icon_moji_iine_20px.png" alt="nice" />
                  </Button>
                </OverlayTrigger>
                <p className="video-total-like">{video.countWantToEat + video.countWantToTry + video.countLiked}</p>
                <p className="video-count-viewed">再生回数: {countViewed}</p>
              </>
            )}
          <p className="video-title text-truncate" title={video.title}>{video.title}</p>
          <Link to={`/shop/${video.storeId}`} className="video-store-name text-truncate">
            {video.storeName}
          </Link>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default VideoPopup
